// import React, { useEffect, useRef, useState } from "react";
// import { io } from "socket.io-client";
// import Peer from "simple-peer";
// import { BiPhone, BiPhoneIncoming } from "react-icons/bi";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import { MdCancel } from "react-icons/md";
// import { useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { toast } from "sonner";

// const url = process.env.REACT_BASE_URL;
// // const socket = io('https://backend.ejobs.com.ng');
// const socket = io(url);

// function InterviewPeer() {
//   const [stream, setStream] = useState(null);
//   const [me, setMe] = useState("");
//   const [idToCall, setIdToCall] = useState("");
//   const [call, setCall] = useState({});
//   const [callAccepted, setCallAccepted] = useState(false);
//   const [callEnded, setCallEnded] = useState(false);
//   const [name, setName] = useState("");
//   const currentUser = useSelector((state) => state.user.currentUser);

//   const [openChat, setOpenChat] = useState(false);
//   const [inputMessage, setInputMessage] = useState("");
//   const [message, setMessage] = useState([]);
//   const { interviewId } = useParams();

//   const myVideo = useRef();
//   const userVideo = useRef();
//   const connectionRef = useRef();

//   useEffect(() => {
//     navigator.mediaDevices
//       .getUserMedia({ video: true, audio: true })
//       .then((currentStream) => {
//         setStream(currentStream);
//         if (myVideo.current) {
//           myVideo.current.srcObject = currentStream;
//         }
//       })
//       .catch((error) => {
//         console.error("Error accessing media devices:", error);
//       });

//     socket.on("me", (id) => {
//       setMe(id);
//       toast.success("user connected");
//     });
//     socket.on("callUser", ({ from, name: callerName, signal }) => {
//       setCall({ isReceivedCall: true, from, name: callerName, signal });
//     });

//     return () => {
//       socket.off("me");
//       socket.off("callUser");
//     };
//   }, []);

//   useEffect(() => {
//     socket.emit("join_interview", interviewId);

//     socket.on("receive_message", (message) => {
//       setMessage((prevMessages) => [...prevMessages, message]);
//     });

//     return () => {
//       socket.emit("leave_interview", interviewId);
//       socket.off("receive_message");
//     };
//   }, [interviewId]);

//   const sendMessage = () => {
//     if (inputMessage.trim()) {
//       const messageData = {
//         author: name || currentUser?.name || "Anonymous",
//         message: inputMessage,
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//       };
//       socket.emit("send_message", { interviewId, message: messageData });
//       setInputMessage("");
//     }
//   };

//   const answerCall = () => {
//     setCallAccepted(true);
//     const peer = new Peer({ initiator: false, trickle: false, stream });

//     peer.on("signal", (data) => {
//       socket.emit("answerCall", { signal: data, to: call.from });
//     });

//     peer.on("stream", (currentStream) => {
//       if (userVideo.current) {
//         userVideo.current.srcObject = currentStream;
//       }
//     });

//     peer.signal(call.signal);
//     connectionRef.current = peer;
//   };

//   const callUser = (id) => {
//     const peer = new Peer({ initiator: true, trickle: false, stream });

//     peer.on("signal", (data) => {
//       socket.emit("callUser", {
//         userToCall: id,
//         signalData: data,
//         from: me,
//         name,
//       });
//     });

//     socket.on("callAccepted", (signal) => {
//       setCallAccepted(true);
//       peer.signal(signal);
//     });

//     peer.on("stream", (currentStream) => {
//       if (userVideo.current) {
//         userVideo.current.srcObject = currentStream;
//       }
//     });

//     connectionRef.current = peer;
//   };

//   const leaveCall = () => {
//     setCallEnded(true);
//     if (connectionRef.current) connectionRef.current.destroy();
//     window.location.reload();
//   };

//   const handleChat = () => {
//     setOpenChat(!openChat);
//   };

//   return (
//     <div className="min-h-screen bg-gray-900 flex flex-col overflow-hidden">
//       {/* Main Video Section */}
//       <div className="relative flex-1 flex items-center justify-center bg-gray-950">
//         {/* My Video (Picture-in-Picture) */}
//         {stream && (
//           <div className="absolute top-4 right-4 z-10 w-40 h-40 rounded-lg overflow-hidden shadow-lg border border-gray-700">
//             <video
//               className="w-full h-full object-cover"
//               playsInline
//               muted
//               ref={myVideo}
//               autoPlay
//             />
//             <div className="absolute bottom-0 left-0 w-full bg-gray-800 bg-opacity-75 text-white text-center py-1 text-sm">
//               {name || currentUser?.name || "Me"}
//             </div>
//           </div>
//         )}

//         {/* User Video (Main) */}
//         <div className="w-full h-full">
//           {callAccepted && !callEnded ? (
//             <video
//               className="w-full h-full object-cover"
//               playsInline
//               ref={userVideo}
//               autoPlay
//             />
//           ) : (
//             <div className="flex items-center justify-center h-full text-gray-400 text-xl">
//               Waiting for connection...
//             </div>
//           )}
//         </div>

//         {/* Control Panel */}
//         <div className="absolute left-4 top-1/2 transform -translate-y-1/2 w-72 bg-white bg-opacity-95 rounded-lg shadow-lg p-6 space-y-6">
//           <div className="space-y-2">
//             <label
//               className="block text-sm font-medium text-gray-700"
//               htmlFor="name"
//             >
//               Your Name
//             </label>
//             <input
//               id="name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               placeholder="Enter your name"
//               type="text"
//               className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//             />
//             <CopyToClipboard text={me}>
//               <button className="w-full py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition">
//                 Copy Your ID
//               </button>
//             </CopyToClipboard>
//           </div>

//           {call.isReceivedCall && !callAccepted && (
//             <button
//               onClick={answerCall}
//               className="w-full flex items-center justify-center gap-2 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
//             >
//               <BiPhoneIncoming /> Answer Call
//             </button>
//           )}

//           <div className="space-y-2">
//             <label
//               className="block text-sm font-medium text-gray-700"
//               htmlFor="idToCall"
//             >
//               Make a Call
//             </label>
//             <input
//               id="idToCall"
//               value={idToCall}
//               onChange={(e) => setIdToCall(e.target.value)}
//               placeholder="Enter ID to call"
//               type="text"
//               className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//             />
//             {callAccepted && !callEnded ? (
//               <button
//                 onClick={leaveCall}
//                 className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
//               >
//                 Hang Up
//               </button>
//             ) : (
//               <button
//                 onClick={() => callUser(idToCall)}
//                 className="w-full flex items-center justify-center gap-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
//               >
//                 <BiPhone /> Call
//               </button>
//             )}
//             <button
//               onClick={handleChat}
//               className="w-full py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition"
//             >
//               {openChat ? "Close Chat" : "Open Chat"}
//             </button>
//           </div>
//         </div>

//         {/* Chat Panel */}
//         {openChat && (
//           <div className="absolute bottom-4 right-4 w-96 h-[70vh] bg-white rounded-lg shadow-lg flex flex-col">
//             <div className="flex justify-between items-center p-4 border-b border-gray-200">
//               <h3 className="text-lg font-semibold text-gray-800">Chat</h3>
//               <MdCancel
//                 className="text-red-500 cursor-pointer w-6 h-6 hover:text-red-600"
//                 onClick={handleChat}
//               />
//             </div>
//             <div className="flex-1 overflow-y-auto p-4 space-y-4">
//               {message.map((msg, index) => (
//                 <div
//                   key={index}
//                   className={`p-3 rounded-lg max-w-[80%] ${
//                     msg.author === name || msg.author === currentUser?.name
//                       ? "bg-blue-100 ml-auto"
//                       : "bg-gray-100"
//                   }`}
//                 >
//                   <div className="font-medium text-gray-800">{msg.author}</div>
//                   <div className="text-gray-700">{msg.message}</div>
//                   <div className="text-xs text-gray-500 mt-1">{msg.time}</div>
//                 </div>
//               ))}
//             </div>
//             <div className="p-4 border-t border-gray-200 space-y-2">
//               <button
//                 onClick={() => {
//                   const messageData = {
//                     author: name || currentUser?.name || "Anonymous",
//                     message: `My ID is: ${me}`,
//                     time: new Date().toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     }),
//                   };
//                   socket.emit("send_message", {
//                     interviewId,
//                     message: messageData,
//                   });
//                 }}
//                 className="w-full py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
//               >
//                 Share My ID
//               </button>
//               <div className="flex gap-2">
//                 <input
//                   value={inputMessage}
//                   onChange={(e) => setInputMessage(e.target.value)}
//                   onKeyDown={(e) => e.key === "Enter" && sendMessage()}
//                   placeholder="Type a message..."
//                   className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                 />
//                 <button
//                   onClick={sendMessage}
//                   className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
//                 >
//                   Send
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default InterviewPeer;












import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import Peer from "simple-peer";
import { BiPhone, BiPhoneIncoming } from "react-icons/bi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "sonner";

const url = process.env.REACT_BASE_URL;
const socket = io(url, { reconnect: true, transports: ["websocket"] });

function InterviewPeer() {
  const [stream, setStream] = useState(null);
  const [me, setMe] = useState("");
  const [idToCall, setIdToCall] = useState("");
  const [call, setCall] = useState({});
  const [callAccepted, setCallAccepted] = useState(false);
  const [callEnded, setCallEnded] = useState(false);
  const [name, setName] = useState("");
  const [openChat, setOpenChat] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [message, setMessage] = useState([]);
  const { interviewId } = useParams();
  const currentUser = useSelector((state) => state.user.currentUser);

  const myVideo = useRef(null);
  const userVideo = useRef(null);
  const connectionRef = useRef(null);

  // Initialize media stream and socket connection
  useEffect(() => {
    if (!interviewId) {
      toast.error("Invalid interview ID");
      return;
    }

    // Get user media
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((currentStream) => {
        setStream(currentStream);
        if (myVideo.current) {
          myVideo.current.srcObject = currentStream;
        }
      })
      .catch((error) => {
        console.error("Error accessing media devices:", error);
        toast.error("Failed to access camera or microphone. Please check permissions.");
      });

    // Socket event listeners
    socket.on("connect", () => {
      socket.emit("join_interview", interviewId);
      toast.success("Connected to interview room");
    });

    socket.on("me", (id) => {
      setMe(id);
      toast.success("User ID assigned: " + id);
    });

    socket.on("callUser", ({ from, name: callerName, signal }) => {
      setCall({ isReceivedCall: true, from, name: callerName, signal });
      toast.info(`Incoming call from ${callerName}`);
    });

    socket.on("receive_message", (message) => {
      setMessage((prevMessages) => [...prevMessages, message]);
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
      toast.error("Failed to connect to server. Retrying...");
    });

    // Cleanup on unmount
    return () => {
      socket.emit("leave_interview", interviewId);
      socket.off("me");
      socket.off("callUser");
      socket.off("receive_message");
      socket.off("connect_error");
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      if (connectionRef.current) {
        connectionRef.current.destroy();
      }
    };
  }, [interviewId]);

  const sendMessage = () => {
    if (!inputMessage.trim()) return;
    const messageData = {
      author: name || currentUser?.name || "Anonymous",
      message: inputMessage,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
    socket.emit("send_message", { interviewId, message: messageData });
    setInputMessage("");
  };

  const answerCall = () => {
    if (!stream) {
      toast.error("No media stream available");
      return;
    }
    setCallAccepted(true);
    const peer = new Peer({ initiator: false, trickle: false, stream });

    peer.on("signal", (data) => {
      socket.emit("answerCall", { signal: data, to: call.from });
    });

    peer.on("stream", (currentStream) => {
      if (userVideo.current) {
        userVideo.current.srcObject = currentStream;
      }
    });

    peer.on("error", (err) => {
      console.error("Peer error:", err);
      toast.error("Error in peer connection");
    });

    peer.signal(call.signal);
    connectionRef.current = peer;
  };

  const callUser = (id) => {
    if (!id) {
      toast.error("Please enter a valid ID to call");
      return;
    }
    if (!stream) {
      toast.error("No media stream available");
      return;
    }
    const peer = new Peer({ initiator: true, trickle: false, stream });

    peer.on("signal", (data) => {
      socket.emit("callUser", {
        userToCall: id,
        signalData: data,
        from: me,
        name: name || currentUser?.name || "Anonymous",
      });
    });

    peer.on("stream", (currentStream) => {
      if (userVideo.current) {
        userVideo.current.srcObject = currentStream;
      }
    });

    peer.on("error", (err) => {
      console.error("Peer error:", err);
      toast.error("Error in peer connection");
    });

    socket.on("callAccepted", (signal) => {
      setCallAccepted(true);
      peer.signal(signal);
    });

    connectionRef.current = peer;
  };

  const leaveCall = () => {
    setCallEnded(true);
    if (connectionRef.current) {
      connectionRef.current.destroy();
    }
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    socket.emit("leave_interview", interviewId);
    toast.info("Call ended");
    window.location.reload();
  };

  const handleChat = () => {
    setOpenChat(!openChat);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col overflow-hidden">
      {/* Main Video Section */}
      <div className="relative flex-1 flex items-center justify-center bg-gray-950">
        {/* My Video (Picture-in-Picture) */}
        {stream && (
          <div className="absolute top-4 right-4 z-10 w-40 h-40 rounded-lg overflow-hidden shadow-lg border border-gray-700">
            <video
              className="w-full h-full object-cover"
              playsInline
              muted
              ref={myVideo}
              autoPlay
            />
            <div className="absolute bottom-0 left-0 w-full bg-gray-800 bg-opacity-75 text-white text-center py-1 text-sm">
              {name || currentUser?.name || "Me"}
            </div>
          </div>
        )}

        {/* User Video (Main) */}
        <div className="w-full h-full">
          {callAccepted && !callEnded ? (
            <video
              className="w-full h-full object-cover"
              playsInline
              ref={userVideo}
              autoPlay
            />
          ) : (
            <div className="flex items-center justify-center h-full text-gray-400 text-xl">
              {call.isReceivedCall && !callAccepted
                ? `Incoming call from ${call.name}...`
                : "Waiting for connection..."}
            </div>
          )}
        </div>

        {/* Control Panel */}
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 w-72 bg-white bg-opacity-95 rounded-lg shadow-lg p-6 space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700" htmlFor="name">
              Your Name
            </label>
            <input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              type="text"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <CopyToClipboard text={me} onCopy={() => toast.success("ID copied to clipboard")}>
              <button className="w-full py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition">
                Copy Your ID
              </button>
            </CopyToClipboard>
          </div>

          {call.isReceivedCall && !callAccepted && (
            <button
              onClick={answerCall}
              className="w-full flex items-center justify-center gap-2 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
            >
              <BiPhoneIncoming /> Answer Call
            </button>
          )}

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700" htmlFor="idToCall">
              Make a Call
            </label>
            <input
              id="idToCall"
              value={idToCall}
              onChange={(e) => setIdToCall(e.target.value)}
              placeholder="Enter ID to call"
              type="text"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            {callAccepted && !callEnded ? (
              <button
                onClick={leaveCall}
                className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
              >
                Hang Up
              </button>
            ) : (
              <button
                onClick={() => callUser(idToCall)}
                className="w-full flex items-center justify-center gap-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              >
                <BiPhone /> Call
              </button>
            )}
            <button
              onClick={handleChat}
              className="w-full py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600 transition"
            >
              {openChat ? "Close Chat" : "Open Chat"}
            </button>
          </div>
        </div>

        {/* Chat Panel */}
        {openChat && (
          <div className="absolute bottom-4 right-4 w-96 h-[70vh] bg-white rounded-lg shadow-lg flex flex-col">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800">Chat</h3>
              <MdCancel
                className="text-red-500 cursor-pointer w-6 h-6 hover:text-red-600"
                onClick={handleChat}
              />
            </div>
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              {message.map((msg, index) => (
                <div
                  key={index}
                  className={`p-3 rounded-lg max-w-[80%] ${
                    msg.author === (name || currentUser?.name)
                      ? "bg-blue-100 ml-auto"
                      : "bg-gray-100"
                  }`}
                >
                  <div className="font-medium text-gray-800">{msg.author}</div>
                  <div className="text-gray-700">{msg.message}</div>
                  <div className="text-xs text-gray-500 mt-1">{msg.time}</div>
                </div>
              ))}
            </div>
            <div className="p-4 border-t border-gray-200 space-y-2">
              <button
                onClick={() => {
                  const messageData = {
                    author: name || currentUser?.name || "Anonymous",
                    message: `My ID is: ${me}`,
                    time: new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    }),
                  };
                  socket.emit("send_message", { interviewId, message: messageData });
                }}
                className="w-full py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
              >
                Share My ID
              </button>
              <div className="flex gap-2">
                <input
                  value={inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                  placeholder="Type a message..."
                  className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <button
                  onClick={sendMessage}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InterviewPeer;